export class StudentDigitalContent {
    Id: number;
    DocumentId: number;
    DocumentOwnerId: number;
    DocumentTypeId: number;
    DocumentType: string;
    FileName: string;
    OriginalFileName: string;
    Description: string;
    UploadedDate: Date;
    MyFileBase64String: string;
    FileExtension: string;
    FileType: string;
    FormAddedBy: string;
    DocumentMimeType: string;
    ParentId: number;
    Family_ID?:number;
   }
